module.exports = __webpack_public_path__ + "static/media/splash_3.cafad1a8.webp";